import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectKanban from "@/pages/ProjectKanban";
import Team from "@/pages/Team";
import Notes from "@/pages/Notes";
import TimeTracking from "@/pages/TimeTracking";
import AIChat from "@/pages/AIChat";
import Settings from "@/pages/Settings";
import { Toaster } from "sonner";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-black text-neutral-500 font-jet text-sm">
        <span>// authenticating<span className="terminal-cursor" /></span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/projects" element={<Protected><Projects /></Protected>} />
          <Route path="/app/projects/:id" element={<Protected><ProjectKanban /></Protected>} />
          <Route path="/app/team" element={<Protected><Team /></Protected>} />
          <Route path="/app/notes" element={<Protected><Notes /></Protected>} />
          <Route path="/app/time" element={<Protected><TimeTracking /></Protected>} />
          <Route path="/app/ai" element={<Protected><AIChat /></Protected>} />
          <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
